// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EdDdrKcseB {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.EdDdrKcseB h4 {
  line-height: 3em;
}
.EdDdrKcseB .wgZeSwd0Z5 {
  float: left;
  width: 100%;
}
.EdDdrKcseB .M4m0SXhEYy {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.EdDdrKcseB .M4m0SXhEYy:hover {
  cursor: pointer;
}
.EdDdrKcseB .M4m0SXhEYy:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.KaQ_FuXqOr .zHj624zeJg:focus {
  outline: none;
}
.KaQ_FuXqOr .zHj624zeJg.ncT7sK_krk.c_8p48Tpo4 {
  background: #375A88;
}
.KaQ_FuXqOr .zHj624zeJg.ncT7sK_krk.c_8p48Tpo4 span {
  color: #fff;
}
.KaQ_FuXqOr .c_8p48Tpo4 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.KaQ_FuXqOr .c_8p48Tpo4:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.KaQ_FuXqOr input {
  height: 38px;
  min-width: 220px;
}
.M4m0SXhEYy.Wk8FU3SOHQ {
  background: #410102;
}
.M4m0SXhEYy.fpQQ7KoW9R {
  background: #911318;
}
.M4m0SXhEYy.utde9021ZT {
  background: #D8293B;
}
.M4m0SXhEYy.aCu_ExG1f2 {
  background: #F2373C;
}
.M4m0SXhEYy.RiSIRGRT7n {
  background: #FC4448;
}
.M4m0SXhEYy.YxFs3Y42EF {
  background: #ED535E;
}
.M4m0SXhEYy.KU4k6xwaHt {
  background: #E34926;
}
.M4m0SXhEYy.bg2pEqfJyh {
  background: #FC562B;
}
.M4m0SXhEYy.hD1Xh3bsBu {
  background: #FC6722;
}
.M4m0SXhEYy.P4Wl8HfQzx {
  background: #FD7F24;
}
.M4m0SXhEYy.QrOdUaoJ1c {
  background: #FD8D26;
}
.M4m0SXhEYy.aIVTc2Vapd {
  background: #EC9C3E;
}
.M4m0SXhEYy.QiKcyzQ8og {
  background: #0e673a;
}
.M4m0SXhEYy.ppbAWli4l2 {
  background: #208740;
}
.M4m0SXhEYy.FtsQzOn8oE {
  background: #239718;
}
.M4m0SXhEYy.OynA3Sjag9 {
  background: #55A84D;
}
.M4m0SXhEYy.NzFYzl64Z2 {
  background: #4BBE5A;
}
.M4m0SXhEYy.UPAJaW5mTU {
  background: #0CCA6A;
}
.M4m0SXhEYy.WkuPFQtQxk {
  background: #0A3C64;
}
.M4m0SXhEYy.QaoPtE51rR {
  background: #0d487a;
}
.M4m0SXhEYy.P7lLBvlEzB {
  background: #10538d;
}
.M4m0SXhEYy.Ahx11LTuIr {
  background: #115A99;
}
.M4m0SXhEYy.h5gZL85kjJ {
  background: #3387E2;
}
.M4m0SXhEYy.UY9oXe1H0p {
  background: #1BA9CF;
}
.M4m0SXhEYy.BqZiGV3Ruz {
  background: #d27c02;
}
.M4m0SXhEYy.Pl4dSTdy5Q {
  background: #fb9402;
}
.M4m0SXhEYy.isM44ubmKU {
  background: #FD9B30;
}
.M4m0SXhEYy.Jod5yDkVDF {
  background: #FDBE2D;
}
.M4m0SXhEYy.polbny5OiE {
  background: #FED831;
}
.M4m0SXhEYy.pIG3r0sqLu {
  background: #FFFD38;
}
.M4m0SXhEYy.PiYDXW1d4Z {
  background: #2D215C;
}
.M4m0SXhEYy.DOy3Z5ax1Q {
  background: #483C83;
}
.M4m0SXhEYy.KEXuEpphU7 {
  background: #58518d;
}
.M4m0SXhEYy.GspMopjOlx {
  background: #7068A9;
}
.M4m0SXhEYy.Nj7qJOisKJ {
  background: #7f78b2;
}
.M4m0SXhEYy.M8pSbUvDx4 {
  background: #8f88bc;
}
.M4m0SXhEYy.wbKFrejyzJ {
  background: #000;
}
.M4m0SXhEYy.uxzmvnMlRt {
  background: #282626;
}
.M4m0SXhEYy.FmlFFF4GYZ {
  background: #242222;
}
.M4m0SXhEYy.kvuD0B9V0o {
  background: #353838;
}
.M4m0SXhEYy.FXJD_uvjgB {
  background: #666;
}
.M4m0SXhEYy.YXu2rbjthp {
  background: #999;
}
.mU5yX2NFCb {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.mU5yX2NFCb .iF2lOzWD_T {
  display: none;
}
/* Gray (neutral) */
.t0duvhtqIW {
  display: grid;
  grid-template-rows: repeat(autofill, 1fr);
  grid-row-gap: 16px;
  padding-top: 16px;
}
.t0duvhtqIW .n3YFwg98Tb {
  display: flex;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW {
  padding: 0 16px;
  flex: 1 1 0;
  min-width: 0;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW > label {
  font-size: 12px !important;
  margin-bottom: 8px;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .w7OSASRl_w {
  display: flex;
  justify-content: flex-start;
  gap: 4px;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .w7OSASRl_w > label {
  font-size: 12px !important;
  margin-bottom: 8px;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn {
  position: relative;
  height: 32px;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn .MuiInput-root {
  outline: none;
  height: 32px;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn .MuiOutlinedInput-notchedOutline {
  border-color: #E4E4E6;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn input {
  padding: 0;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn input:focus {
  outline: none;
  border: 0;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn button {
  padding: 0;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .k1NNkJm1tn button i {
  font-size: 13px;
}
.t0duvhtqIW .n3YFwg98Tb ._H_z5cY7Nq {
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 20px;
  border: 1px solid #E4E4E6;
  border-radius: 4px;
  padding: 0 8px;
}
.t0duvhtqIW .n3YFwg98Tb ._H_z5cY7Nq .flatpickr-calendar {
  left: -150px;
}
.t0duvhtqIW .n3YFwg98Tb ._H_z5cY7Nq .flatpickr-calendar::after {
  left: 160px;
}
.t0duvhtqIW .n3YFwg98Tb ._H_z5cY7Nq .flatpickr-calendar::before {
  left: 160px;
}
.t0duvhtqIW .n3YFwg98Tb ._H_z5cY7Nq .MelnKo4KLN {
  font-size: 12px;
}
.t0duvhtqIW .n3YFwg98Tb ._H_z5cY7Nq .Nu_QTNK5Fi {
  border: none !important;
  margin-bottom: 0;
  padding-left: 4px;
  width: 80px;
}
.t0duvhtqIW .n3YFwg98Tb .oiPA9TpiGW .yp47txDi5l {
  width: 100%;
}
.Vy7VNjjqZZ .W4TCvkiV5J {
  align-items: center;
  background-color: #fff;
  border: none;
  position: relative;
  padding: 0px;
}
.Vy7VNjjqZZ .dSZwTliqPf {
  color: red;
}
.Vy7VNjjqZZ .dSZwTliqPf::after {
  border-color: #EA3344;
  color: #EA3344;
}
.Vy7VNjjqZZ .gJyXHy1JTa {
  font-size: 10px;
  padding: 4px;
}
.NGtlOflvnQ.NGtlOflvnQ {
  background-color: #fff;
  border: none;
  box-shadow: none;
}
.NGtlOflvnQ.NGtlOflvnQ > div:last-child {
  margin-top: 0;
}
.MchQMw5bIG .hYZTEbReDn {
  min-width: 300px;
  width: 100%;
}
.zBLMxNADMC {
  max-height: 196px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `EdDdrKcseB`,
	"color-row": `wgZeSwd0Z5`,
	"color-tile": `M4m0SXhEYy`,
	"picker-component": `KaQ_FuXqOr`,
	"picker-element": `zHj624zeJg`,
	"active": `ncT7sK_krk`,
	"btn": `c_8p48Tpo4`,
	"red-1": `Wk8FU3SOHQ`,
	"red-2": `fpQQ7KoW9R`,
	"red-3": `utde9021ZT`,
	"red-4": `aCu_ExG1f2`,
	"red-5": `RiSIRGRT7n`,
	"red-6": `YxFs3Y42EF`,
	"orange-1": `KU4k6xwaHt`,
	"orange-2": `bg2pEqfJyh`,
	"orange-3": `hD1Xh3bsBu`,
	"orange-4": `P4Wl8HfQzx`,
	"orange-5": `QrOdUaoJ1c`,
	"orange-6": `aIVTc2Vapd`,
	"green-1": `QiKcyzQ8og`,
	"green-2": `ppbAWli4l2`,
	"green-3": `FtsQzOn8oE`,
	"green-4": `OynA3Sjag9`,
	"green-5": `NzFYzl64Z2`,
	"green-6": `UPAJaW5mTU`,
	"blue-1": `WkuPFQtQxk`,
	"blue-2": `QaoPtE51rR`,
	"blue-3": `P7lLBvlEzB`,
	"blue-4": `Ahx11LTuIr`,
	"blue-5": `h5gZL85kjJ`,
	"blue-6": `UY9oXe1H0p`,
	"yellow-1": `BqZiGV3Ruz`,
	"yellow-2": `Pl4dSTdy5Q`,
	"yellow-3": `isM44ubmKU`,
	"yellow-4": `Jod5yDkVDF`,
	"yellow-5": `polbny5OiE`,
	"yellow-6": `pIG3r0sqLu`,
	"purple-1": `PiYDXW1d4Z`,
	"purple-2": `DOy3Z5ax1Q`,
	"purple-3": `KEXuEpphU7`,
	"purple-4": `GspMopjOlx`,
	"purple-5": `Nj7qJOisKJ`,
	"purple-6": `M8pSbUvDx4`,
	"black-1": `wbKFrejyzJ`,
	"black-2": `uxzmvnMlRt`,
	"black-3": `FmlFFF4GYZ`,
	"black-4": `kvuD0B9V0o`,
	"black-5": `FXJD_uvjgB`,
	"black-6": `YXu2rbjthp`,
	"picker-theme": `mU5yX2NFCb`,
	"arrow-regular": `iF2lOzWD_T`,
	"stage-settings__root": `t0duvhtqIW`,
	"stage-settings__row": `n3YFwg98Tb`,
	"stage-settings__item": `oiPA9TpiGW`,
	"stage-settings__item--label": `w7OSASRl_w`,
	"date-picker__root": `k1NNkJm1tn`,
	"stage-settings__item--time": `_H_z5cY7Nq`,
	"time-picker__icon": `MelnKo4KLN`,
	"time-picker__text-field": `Nu_QTNK5Fi`,
	"stage-settings__menu": `yp47txDi5l`,
	"customSelectRoot": `Vy7VNjjqZZ`,
	"customSelectContainer": `W4TCvkiV5J`,
	"customSelectContainer--valid": `dSZwTliqPf`,
	"customSelectLabel": `gJyXHy1JTa`,
	"customSelect": `NGtlOflvnQ`,
	"stage-settings__menuCtn": `MchQMw5bIG`,
	"stage-settings__select": `hYZTEbReDn`,
	"stage-settings___menuList": `zBLMxNADMC`
};
export default ___CSS_LOADER_EXPORT___;
